var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"LevelSuccessViewDebug"},[_vm._v("\n    LevelSuccessViewDebug\n    "),_c('button',{on:{"click":function($event){return _vm.showLevelCompletedPopup()}}},[_vm._v("\n        Test Level-completed popup\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }